export default {
      id: "reports_driving-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.svg#reports_driving",
      toString: function () {
        return this.url;
      }
    }